<template>
  <div class="member-center-page">
    <div class="profile-header">
        <button class="header-exit-btn" @click="handleExit">
          <img src="../assets/btn_sign out@2x.png" alt="">
          <span>退会</span>
        </button>
      <div class="profile-avatar" @click="previewAvatar">
          <img :src="baseInfo.avatarLink || defaultPhoto" alt="">
          <div @click.stop>
            <van-uploader :before-read="onSelectAvatar" accept="image/*">
              <div class="avatar-edit-tip">编辑头像</div>
            </van-uploader>
          </div>
      </div>

      <div class="profile-name">{{ baseInfo.name || baseInfo.nickName || '会员' }}</div>
      <div class="profile-id">会员编号：{{ baseInfo.serialNumber || '--' }}</div>
      <div class="profile-status" @click="$router.push({name: 'editInfos',params:{router:'memberCenter'}})">{{ getEmotionalStatusText(baseInfo.emotionalStatus) }}</div>

      <div class="profile-tags">
        <span class="profile-chip">{{ baseInfo.hometown || '未填写籍贯' }}</span>
        <span class="profile-chip">{{ getFormatTime(baseInfo.birthday) || '未填写生日' }}</span>
        <span class="profile-chip">{{ getEducationText(baseInfo.education) || '未填写学历' }}</span>
        <span class="profile-chip">{{ baseInfo.height ? baseInfo.height + 'cm' : '未填写身高' }}</span>
      </div>

      <div class="profile-actions">
        <button class="profile-action-btn primary" @click="$router.push({name: 'editInfos',params:{router:'memberCenter'}})">资料编辑</button>
      </div>
      </div>

    <!--<div class="profile-shortcuts">
      <div class="profile-shortcut" @click="$router.push({name: 'editInfos',params:{router:'memberCenter'}})">
        <div class="shortcut-number">1</div>
        <div class="shortcut-label">资料编辑</div>
      </div>
      <div class="profile-shortcut" @click="handleGoBrowsingHistory('query')">
        <div class="shortcut-number">2</div>
        <div class="shortcut-label">会员查询</div>
      </div>
      <div class="profile-shortcut" @click="$router.push({path: '/activity'})">
        <div class="shortcut-number">3</div>
        <div class="shortcut-label">活动报名</div>
      </div>
    </div>
    -->

    <div class="dashboard-card">
      <div class="dashboard-title">我的标签</div>

      <div class="tag-section">
        <div class="tag-section-label">我是这样的人</div>
        <div class="tag-section-content" v-if="personalityTags.length > 0">
          <span
            class="member-tag personality"
            v-for="(tag, index) in personalityTags"
            :key="'personality-' + index"
          >
            {{ tag.tagName }}
          </span>
        </div>
        <div class="tag-empty" v-else>暂无标签</div>
      </div>

      <div class="tag-section">
        <div class="tag-section-label">我想找这样的人</div>
        <div class="tag-section-content" v-if="spouseRequirementTags.length > 0">
          <span
            class="member-tag spouse"
            v-for="(tag, index) in spouseRequirementTags"
            :key="'spouse-' + index"
          >
            {{ tag.tagName }}
          </span>
        </div>
        <div class="tag-empty" v-else>暂无标签</div>
      </div>
    </div>

    <div class="menu-card">
      <div class="menu-item" @click="handleGoBrowsingHistory('check')">
        <div class="menu-icon">
          <van-icon name="underway-o" />
        </div>
        <div class="menu-text">浏览记录</div>
        <van-icon name="arrow" />
      </div>

      <div class="menu-item" @click="$router.push({path: '/favoriteMatchmaker'})">
        <div class="menu-icon">
          <van-icon name="star-o" />
        </div>
        <div class="menu-text">收藏的红娘</div>
        <van-icon name="arrow" />
      </div>

      <div class="menu-item" @click="$router.push({path: '/myFavoriteMembers'})">
        <div class="menu-icon">
          <van-icon name="like-o" />
        </div>
        <div class="menu-text">我的心仪对象</div>
        <van-icon name="arrow" />
      </div>
      <div class="menu-item" @click="handleSignOut">
        <div class="menu-icon">
          <van-icon name="close" />
        </div>
        <div class="menu-text">退出登录</div>
        <van-icon name="arrow" />
      </div>
    </div>

    <TabBar active-key="memberCenter" />

    <van-dialog v-model="exitShow" title="退会理由" :show-confirm-button="false" class="exitReason-dialog">
      <template #default>
        <van-field
          v-model="exitReason"
          placeholder="请输入退会理由"
        />
        <span class="exitReason-title">温馨提醒：如您确定退会，将无法进入会员界面查询相关信息，同时也无法报名参加活动</span>
        <div class="exitMember-footer">
          <van-button round type="info" class="exitMember-footer-cancal" @click="exitMemberCancal">取消退会</van-button>
          <van-button round type="info" class="exitMember-footer-success" @click="exitMemberOk" :loading="exitLoading">确认退会</van-button>
        </div>
      </template>
    </van-dialog>
    <avatar-cropper
      :visible.sync="cropperVisible"
      :img-src="rawImgSrc"
      :fixedNumber="fixedNumber"
      @confirm="onCropConfirm"
      @cancel="onCropCancel"
    />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
import defaultPhoto from "../assets/defaultPhoto.png";
import { mapGetters } from "vuex";
import { Toast, ImagePreview } from "vant";
import { getMemberTags, updateUserInfo, upLoadImages } from "@/api/user";
import AvatarCropper from "../components/AvatarCropper.vue";

export default {
  components: { TabBar, AvatarCropper },
  data() {
    return {
      exitShow: false,
      exitReason: "",
      exitLoading: false,
      defaultPhoto,
        fixedNumber: [1, 1],
        cropperVisible: false,
        rawImgSrc: "",
      personalityTags: [],
      spouseRequirementTags: [],
      emotionalStatusOptions: {
        1: "单身ing",
        // 2: "暗恋中",
        // 3: "暧昧中",
        4: "恋爱ing",
        // 5: "订婚",
        // 6: "已结婚",
        // 99: "其他"
      }
    };
  },
  computed: {
    ...mapGetters([
      "baseInfo",
      "role"
    ])
  },
  methods: {
    getEmotionalStatusText(status) {
      return this.emotionalStatusOptions[status] || "单身ing";
    },
    getEducationText(education) {
      const educationMap = {
        1: "大专",
        2: "本科",
        3: "硕士",
        4: "博士",
        5: "高中及以下"
      };
      return educationMap[education] || "";
    },
    async loadMemberTags() {
      if (this.baseInfo && this.baseInfo.id) {
        try {
          const res = await getMemberTags(this.baseInfo.id);
          if (res.code === 20000 && res.data) {
            this.personalityTags = res.data.personalityTags || [];
            this.spouseRequirementTags = res.data.spouseRequirementTags || [];
          }
        } catch (error) {
          console.error("加载会员标签失败", error);
        }
      }
    },
    handleExit() {
      this.exitShow = true;
      this.exitReason = "";
      this.exitLoading = false;
    },
    exitMemberCancal() {
      this.exitShow = false;
    },
    handleGoBrowsingHistory(name) {
      this.$store.dispatch("SetQueryName", name);
      this.$router.push({ path: "/memberBrowsingHistory" });
    },
    exitMemberOk() {
      if (!this.exitReason.trim()) {
        Toast.fail({ message: "请输入退会理由" });
        return;
      }
      this.exitLoading = true;
      let params = {
        reasonForWithdrawal: this.exitReason,
        memberInfoId: this.baseInfo.id
      };
      this.$store.dispatch("DeleteMember", params).then((token) => {
        this.exitLoading = false;
        this.exitShow = false;
        Toast.success({ message: "退会成功" });
        if (token) {
          // 内部人员退会：已切换为普通用户，跳转到首页
          this.$router.push({ path: "/homePage" });
        } else {
          // 外部人员退会：已清除身份，跳转到登录页
          if (location.href.indexOf("?") !== -1) {
            window.location.replace("/mbc/index.html#/");
          } else {
            this.$router.push({ path: "/login" });
          }
        }
      });
    },
    onSelectAvatar(file) {
      this.fixedNumber = [1, 1];
      const reader = new FileReader();
      reader.onload = e => {
        this.rawImgSrc = e.target.result;
        this.cropperVisible = true;
      };
      reader.readAsDataURL(file);
      return false;
    },
    onCropCancel() {
      this.cropperVisible = false;
      this.rawImgSrc = "";
    },
    async onCropConfirm(blob) {
      const formData = new FormData();
      formData.append("formFile", blob, "avatar.jpg");
      try {
        const uploadRes = await upLoadImages(formData);
        if (uploadRes.code !== 20000) {
          Toast({ message: "上传失败" });
          return;
        }
        let data = JSON.parse(JSON.stringify(this.baseInfo));
        data.avatarLink = uploadRes.data;
        const item = await updateUserInfo(data);
        if (item.code === 20000) {
          this.$store.dispatch("UpdateBasicInfo", item.data);
          this.cropperVisible = false;
          this.rawImgSrc = "";
          Toast({ message: "上传成功" });
        } else {
          Toast({ message: "上传失败" });
        }
      } catch (e) {
        Toast({ message: "上传失败" });
      }
    },

    previewAvatar() {
      if (this.baseInfo.avatarLink) {
        ImagePreview({
          images: [this.baseInfo.avatarLink],
          closeable: true,
          closeIconPosition: "top-right"
        });
      }
    },
    handleSignOut() {
      this.$store.dispatch("RemoveToken");
      if (location.href.indexOf("?") !== -1) {
        window.location.replace("/mbc/index.html#/");
      } else {
        this.$router.push({ path: "/login" });
      }
    }
  },
  created() {
    this.loadMemberTags();
  },
  watch: {
    baseInfo: {
      handler() {
        this.loadMemberTags();
      },
      deep: true
    }
  }
};
</script>
<style lang="less" src="../style/memberCenter.less" />



// WEBPACK FOOTER //
// src/views/memberCenter.vue